<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :detail-response-path="detailResponsePath"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getCompany } from '@/services/companies/getCompany'
import { getHistoricalByCIFComp } from '@/services/historical/getHistoricalByCIFComp'
import { getHistoricalByCIFCompExcel } from '@/services/historical/getHistoricalByCIFCompExcel'

export default {
  name: 'list-company-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 19,
      vuexnamespace: 'historicalCompany',
      headerUrl: 'companies/detail',
      detailResponsePath: 'CIFEmpresa',
      breadcrumbs: [
        { url: 'companies', name: i18n.t('companies.header') },
        { paths: ['RazonSocial'] },
      ],
      ExcelName: `${_.kebabCase(i18n.tc('companies.entity_name', 1) + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  methods: {
    getParamsAux: function (data) {
      return { idCIF: this.$route.params.id }
    },
    getParamsDetalleAux: function (data) {
      return { idCIFEmpresa: this.$route.params.id }
    },
    getDetalleAux: async function (params) {
      return await getCompany(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByCIFCompExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByCIFComp(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
